import { doc, getDoc } from 'firebase/firestore';
import { PerformanceCategory } from '../constant/RegisterPageConst.js';
import { db } from '../firebase.js';

export const calculatePriceFromData = (data, isInternational, pricingData) => {
    try {
        let categoryId = data.competitionCategory.toLowerCase();
        if (categoryId === "percussions") {
            categoryId = "percussion";
        }

        let selectedTier = null;

        if (data.PerformanceCategory === PerformanceCategory.Solo) {
            selectedTier = pricingData.fees.find(
                tier => tier.category?.toLowerCase() === data.ageCategory?.toLowerCase()
            );
        } else if (data.PerformanceCategory === PerformanceCategory.Ensemble) {
            selectedTier = pricingData.fees.find(tier => {
                const categoryMatch = tier.category?.toLowerCase() === data.instrumentCategory?.toLowerCase();
                if (!categoryMatch) {
                    return false;
                }

                if (!tier.age_group) {
                    return true;
                }

                return tier.age_group?.toLowerCase() === data.ageCategory?.toLowerCase();
            });
        }

        if (!selectedTier) {
            throw new Error(`Could not find a matching price for the selected options.`);
        }

        let amount = 0;
        let currency = '';

        if (categoryId === 'vocalchoir' && data.PerformanceCategory === PerformanceCategory.Ensemble) {
            const useSpecialPrice = data.totalPerformer === selectedTier.maxPerformers;
            if (isInternational) {
                amount = useSpecialPrice ? selectedTier.internationalPriceSpecial : selectedTier.internationalPriceRegular;
                currency = 'USD';
            } else {
                amount = useSpecialPrice ? selectedTier.nationalPriceSpecial : selectedTier.nationalPriceRegular;
                currency = 'IDR';
            }
        } else {
            if (isInternational) {
                amount = selectedTier.internationalPrice;
                currency = 'USD';
            } else {
                amount = selectedTier.nationalPrice;
                currency = 'IDR';
            }
        }

        if (data.PerformanceCategory === PerformanceCategory.Ensemble && data.totalPerformer > 0) {
            amount = amount * data.totalPerformer;
        }

        return {
            amount: amount,
            currency: currency,
            formattedAmount: `${currency} ${amount.toLocaleString(currency === 'IDR' ? 'id-ID' : 'en-US')}`
        };

    } catch (error) {
        console.error("Price calculation failed:", error);
        return { amount: 0, currency: 'N/A', formattedAmount: 'Not Available' };
    }
};

export const calculatePrice = async (data, isInternational) => {
    try {
        let categoryId = data.competitionCategory.toLowerCase();
        if (categoryId === "percussions") {
            categoryId = "percussion";
        }

        const priceDocRef = doc(db, 'Registration2025Fee', categoryId);
        const priceDocSnap = await getDoc(priceDocRef);

        if (!priceDocSnap.exists()) {
            throw new Error(`Pricing info for category "${categoryId}" not found.`);
        }

        const pricingData = priceDocSnap.data();
        return calculatePriceFromData(data, isInternational, pricingData);
    } catch (error) {
        console.error("Price calculation failed:", error);
        return { amount: 0, currency: 'N/A', formattedAmount: 'Not Available' };
    }
};
